import React from "react";

function MRZSupport() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 60 54">
            <path
                fill="#0068FF"
                d="M53.848 53.848A53.848 53.848 0 000 0v53.848"
            />
            <path
                fill="#FFDB00"
                fillOpacity="0.4"
                d="M59.476 9.127H14.603V54h44.873V9.127z"
            />
        </svg>
    );
}

export default MRZSupport;
